import { combineEpics } from 'redux-observable';

import { createEventEpic } from './CreateEvent/CreateEventEpic';
import { cancelEventEpic } from './CancelEvent/CancelEventEpic';
import { deleteEventEpic } from './DeleteEvent/DeleteEventEpic';
import { findEventsEpic }  from './FindEvents/FindEventsEpic';
import { findEventEpic }   from './FindEvent/FindEventEpic';
import { updateEventEpic } from './UpdateEvent/UpdateEventEpic';
import { downloadEventReportEpic } from './DownloadEventReport/DownloadEventReportEpic';
import { sendBuyerMailEpic }       from './SendBuyerMail/SendBuyerMailEpic';
import { findEventEmployeesEpic }  from './FindEventEmployees/FindEventEmployeesEpic';
import { assignEventEmployeesEpic } from './AssignEventEmployees/AssignEventEmployeesEpic';


export const eventEpics = combineEpics(
  createEventEpic,
  cancelEventEpic,
  deleteEventEpic,
  findEventsEpic,
  findEventEpic,
  updateEventEpic,
  downloadEventReportEpic,
  sendBuyerMailEpic,
  findEventEmployeesEpic,
  assignEventEmployeesEpic,
);
